import { IconButton, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { GridInfoStack } from 'components/atoms/InfoCard'
import whyIcon from 'assets/images/why.svg'
import invitePersonIcon from 'assets/images/invitePerson.svg'
import noteAddIcon from 'assets/images/noteAdd.svg'
import { InfoCardIcon } from 'components/atoms/Icons'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useState } from 'react'
import InfoDialog from '../notificationOverlay/InfoDialog'
import shieldTickIcon from 'assets/images/shieldTick.svg'
import { AssessmentHeadWrapper } from 'components/molecules/assessments/AssessmentMolecules'

export const ConfidentialIcon = () => {
  const { t } = useTranslation()
  const [confidentialDialogOpen, setDisplayConfidentialInfo] = useState(false)
  return (
    <>
      <IconButton onClick={() => setDisplayConfidentialInfo(true)}>
        <InfoOutlinedIcon />
      </IconButton>
      <InfoDialog
        open={confidentialDialogOpen}
        onClose={() => setDisplayConfidentialInfo(false)}
        title={t('confidentiality.heading')}
        buttonText={t('common.ok')}
        icon={shieldTickIcon}>
        <Typography>{t('addRaters.confidentiality')}</Typography>
      </InfoDialog>
    </>
  )
}

const AddRatersDescriptions = () => {
  const { t } = useTranslation()
  return (
    <AssessmentHeadWrapper
      title={t('addRaters.inviteOthersToRate')}
      description={t('addRaters.compareWithFeedback')}>
      <GridInfoStack
        title={t('addRaters.details.item1.title')}
        content={t('addRaters.details.item1.description')}
        icon={<InfoCardIcon src={whyIcon} size={56} />}
      />
      <GridInfoStack
        title={t('addRaters.details.item2.title')}
        content={t('addRaters.details.item2.description')}
        icon={<InfoCardIcon src={invitePersonIcon} size={56} />}
      />
      <GridInfoStack
        title={t('addRaters.details.item3.title')}
        content={t('addRaters.details.item3.description')}
        icon={<InfoCardIcon src={noteAddIcon} size={56} />}
        size={{ sm: 12, md: 12, lg: 3.5 }}
      />
    </AssessmentHeadWrapper>
  )
}

export default AddRatersDescriptions
